import { render, staticRenderFns } from "./StudentProject.vue?vue&type=template&id=fd7e483a"
import script from "./StudentProject.vue?vue&type=script&lang=js"
export * from "./StudentProject.vue?vue&type=script&lang=js"
import style0 from "./StudentProject.vue?vue&type=style&index=0&id=fd7e483a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports